import { ExchangeController } from '../../controllers';
import { useStores, exchangeStore } from '../../stores';
import { WalletExchange } from '../../pages';
import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import { object, string, number, array, boolean, date } from 'yup';
import { walletStore } from '../../stores';
import { WalletController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const WalletExchangeContainer = ({
	closeWalletModal,
	bankAccounts,
	urlSet,
	setShowSurvey,
}) => {
	const wallet = walletStore.selectedWallet;

	const [loading, setLoading] = useState(false);
	const [pinStage, setPinStage] = useState(false);
	const [fee, setFee] = useState(0);
	const { fromCurrency, toCurrency } = exchangeStore.exchangeCurrencies;
	const ngnRate = exchangeStore.currentExchangeRate;

	const { needFeedback } = useGetAllActiveReviews(
		constant.FEEDBACK.WALLETEXCHANGE
	);

	const getExchangeAmount = async amount => {
		setLoading(true);
		let query;
		query = `fromCurrency=${fromCurrency}&toCurrency=${toCurrency}&amount=${amount}`;

		const { status, errorMessage, data } =
			await ExchangeController.getExchangeRateAmount(query);
		setFee(data.charge);
		if (status === constant.Success) {
			setLoading(false);
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
	};

	const {
		userStore,
		exchangeStore: { currentExchangeRate },
	} = useStores();

	const validationSchema = () => {
		return object({
			amount: number().when('validationControl', {
				is: true,
				then: schema =>
					schema
						.min(ngnRate, `Amount to change must be greater than ${ngnRate}`)
						.required('Amount is required'),
				otherwise: schema =>
					schema
						.min(1, `Amount to change must be greater than 1`)
						.required('Amount is required'),
			}),
		});
	};

	const onChangeToCurrency = async () => {
		setLoading(true);
		const value = exchangeStore.exchangeCurrencies;
		let query;
		query = `fromCurrency=${value.fromCurrency}&toCurrency=${value.toCurrency}`;
		await ExchangeController.getCurrentExchangeRate(query);
		setLoading(false);
	};

	const onCloseModal = () => {
		closeWalletModal();
		exchangeStore.setCurrentExchangeRate('');
		exchangeStore.setExchangeCurrencies({});
		exchangeStore.setExchangeRateValue(0);
	};

	const onSubmit = values => {
		delete values.exchangeAmount;
		delete values.validationControl;

		setLoading(true);
		exchangeStore.setExchangePayload(values);
		setPinStage(true);
		setLoading(false);
	};

	const onSubmitPin = async pin => {
		setLoading(true);
		const payload = {
			...exchangeStore.exchangePayload,
			pin: pin,
		};

		const { status, errorMessage } =
			await ExchangeController.changeCurrency(payload);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			onCloseModal();
			if (needFeedback._id) {
				setShowSurvey(true);
				userStore.setReviewId(needFeedback._id);
			}
			return;
		} else {
			setLoading(false);
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
	};

	const goBack = () => {
		if (pinStage) {
			setPinStage(false);
		} else {
			onCloseModal();
		}
	};

	return (
		<WalletExchange
			closeModal={onCloseModal}
			loading={loading}
			fee={fee}
			currentExchangeRate={currentExchangeRate}
			getExchangeAmount={getExchangeAmount}
			onChangeToCurrency={onChangeToCurrency}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			goBack={goBack}
			pinStage={pinStage}
			onSubmitPin={onSubmitPin}
		/>
	);
};

export default WalletExchangeContainer;
